import ConsoleLogger from '../logger/consoleLogger';
import {ClientEvents} from '../constants/clientEvents';

const logger = ConsoleLogger.getPrefixedCopy('CLIENT_EVENT');

export class ClientEventEmitter {
    private static eventScope = 'client';

    public static fireEvent<T extends {}>(inEvent: ClientEvents, inEventData: Partial<T> = {}): void {
        setTimeout(() => {
            const event = this.getScopedEventName(inEvent) as ClientEvents;
            let eventData = inEventData;
            if (typeof inEventData === 'undefined') {
                eventData = {};
            }
            logger.debug(`Fired event ${event}, data ${JSON.stringify(eventData)}`);
            $(document).trigger(event, [eventData]);
        }, 0);
    }


    // eslint-disable-next-line id-length
    public static on<T extends {}>(inEvent: ClientEvents, eventHandler: (event: Event, data: T) => void): void {
        const event = this.getScopedEventName(inEvent) as ClientEvents;
        // @ts-ignore
        $(document).on(event, eventHandler);
        logger.debug(`Subscribed to event ${event}`);
    }

    public static one<T extends {}>(inEvent: ClientEvents, eventHandler: (event: Event, data: T) => void): void {
        const event = this.getScopedEventName(inEvent) as ClientEvents;
        // @ts-ignore
        $(document).one(event, eventHandler);
        logger.debug(`Subscribed to event (once) ${event}`);
    }

    private static getScopedEventName(event: ClientEvents): string {
        return `${event}.${this.eventScope}`;
    }
}
